module.exports = __webpack_public_path__ + "img/53.89385a95.svg";